export type Panel = 'closed' | 'menu' | 'search';
export type OpenPanel = Exclude<Panel, 'closed'>;

export const panelIds = {
  menu: 'bio-mobile-menu',
  search: 'bio-mobile-search',
};

export interface MobileNavigationItem {
  id: string;
  label: string;
  url: string | null;
  newTab: boolean;
  heading: boolean;
  spaceBelow: boolean;
  children: MobileNavigationItem[];
}

export interface MobileNavigationLink {
  label: string;
  href: string;
}

export interface MobileNavigationSignOut {
  action: string;
  csrfToken: string;
}

export interface MobileNavigationSupport {
  title: string;
  links: MobileNavigationLink[];
  clinical: MobileNavigationLink;
}

export type MobileNavigationAccount =
  | { kind: 'signedOut'; signIn: string; register: string }
  | {
      kind: 'signedIn';
      settings: string | null;
      signOut: MobileNavigationSignOut;
    };

export interface MobileNavigationMenu {
  items: MobileNavigationItem[];
  support: MobileNavigationSupport | null;
  engage: { src: string; alt: string; href: string } | null;
}

export interface MobileNavigationProps {
  logo: { src: string; alt: string; href: string | null } | null;
  menu: MobileNavigationMenu | null;
  search: { action: string; query: string } | null;
  account: MobileNavigationAccount | null;
  cart: { href: string; count: number } | null;
}
